import React, { useEffect, useState, useRef } from 'react'
import classnames from 'classnames'
import { getTemplateDetails } from './actions'
import { useParams } from 'react-router-dom'

import deviceSizes from 'Components/PreviewTool/support/deviceSizes'

import { logAppError } from 'Helpers/logger'

import PreviewTools, { Tabs, TabsDesktopOrMobile } from 'Components/PreviewTool'

const PreviewTemplate = () => {
  const { id, local, kind, msgtype } = useParams()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [deviceType, setDeviceType] = useState('desktop')
  const [sizeId, setSizeId] = useState(deviceSizes[0].id)

  const title = useRef(null)
  const content = useRef(null)

  useEffect(() => {
    const fetch = async () => {
      try {
        const { Title, Contents } = await getTemplateDetails(
          id,
          local,
          kind,
          msgtype
        )

        title.current = Title
        content.current = Contents
      } catch (error) {
        logAppError({ appError: error })
        setError(true)
      }
      setLoading(false)
    }

    fetch()
  }, [])

  const size = deviceSizes.find(size => size.id === sizeId)

  const TabsComponent = () =>
    kind === 'bee' ? (
      <Tabs>
        <TabsDesktopOrMobile
          active={deviceType}
          onClickTab={value => setDeviceType(value)}
          onChangeSelect={value => setSizeId(value)}
          selectValue={sizeId}
          showMobile
        />
      </Tabs>
    ) : null

  return (
    <PreviewTools
      TabsComponent={TabsComponent}
      title={title.current}
      content={content.current}
      loading={loading}
      error={error}
      previewers={[
        {
          content: content.current,
          active: deviceType === 'desktop',
          'data-mu-test': classnames('desktop-preview', {
            'desktop-preview--active': deviceType === 'desktop'
          })
        },
        {
          content: content.current,
          width: size.width,
          height: size.height,
          pixelRatio: size.pixelRatio,
          active: deviceType === 'mobile',
          'data-mu-test': classnames('mobile-preview', {
            'mobile-preview--active': deviceType === 'mobile'
          })
        }
      ]}
    />
  )
}

export default PreviewTemplate
